/**
 * Checks if a JWT token is expired
 * @param {string} token - The JWT token to check
 * @returns {boolean} True if the token is expired or invalid, false otherwise
 */
export const isTokenExpired = (token) => {
    if (!token) return true;
    try {
        const base64Url = token.split(".")[1];
        if (!base64Url) return true;
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split("")
                .map(function (c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );
        const { exp } = JSON.parse(jsonPayload);
        if (!exp) return false;

        // Check if token is expired (comparing current time in seconds)
        const currentTime = Math.floor(Date.now() / 1000);
        return currentTime >= exp;
    } catch (error) {
        console.error("Error decoding token:", error);
        return true; // Treat invalid tokens as expired
    }
};
